/* eslint-disable */
// jQuery Alert Dialogs Plugin
//
// Version 1.0
//
// Cory S.N. LaViska
// A Beautiful Site (http://abeautifulsite.net/)
// 29 December 2008
//
// This is an altered version form Aurélien Malisart <aurelien.malisart@gmail.com>
//
// Visit http://github.com/aurels/jquery.alerts
// Visit http://abeautifulsite.net/notebook/87 for more information
//
(function ($) {

  $.alerts = {
    // These properties can be read/written by accessing $.alerts.propertyName from your scripts at any time

    verticalOffset: -75,                // vertical offset of the dialog from center screen, in pixels
    horizontalOffset: 0,                // horizontal offset of the dialog from center screen, in pixels/
    repositionOnResize: true,           // re-centers the dialog on window resize
    overlayOpacity: 0.3,                // transparency level of overlay
    overlayColor: '#000',               // base color of overlay
    draggable: true,                    // make the dialogs draggable (requires UI Draggables plugin)
    okButton: '&nbsp;确定&nbsp;',         // text for the OK button (not used anymore in this version)
    cancelButton: '&nbsp;取消&nbsp;', // text for the Cancel button (not used anymore in this version)
    dialogClass: null,                  // if specified, this class will be applied to all dialogs

    // Public methods

    alert: function (message, ok, callback) {
      ok = ok || '确定'
      $.alerts._show(message, null, ok, null, 'alert', function (result) {
        if (callback) callback(result)
      })
    },

    confirm: function (message, ok, cancel, callback) {
      ok = ok || '确定'
      cancel = cancel || '取消'
      $.alerts._show(message, null, ok, cancel, 'confirm', function (result) {
        if (callback) callback(result)
      })
    },

    prompt: function (message, value, ok, cancel, callback) {
      $.alerts._show(message, value, ok, cancel, 'prompt', function (result) {
        if (callback) callback(result)
      })
    },

    // Private methods

    _show: function (msg, value, ok, cancel, type, callback) {

      $.alerts._hide()
      $.alerts._overlay('show')
      $('BODY').append(
        '<div id="popup_container">' +
        '<div id="popup_title">' +
        '<a id="popup_close" href="javascript:void(0)"></a>' +
        '</div><div id="popup_content">' +
        '<div id="popup_message"></div>' +
        '</div>' +
        '</div>')

      if ($.alerts.dialogClass) $('#popup_container').addClass($.alerts.dialogClass)

      $('#popup_container').css({
        position: 'fixed',
        zIndex: 99999,
        padding: 0,
        margin: 0
      })

      // $("#popup_title").css({
      // 	width: $("#popup_message").width()
      // });

      $('#popup_content').addClass(type)
      $('#popup_message').html(msg)
      // $("#popup_message").html( $("#popup_message").text().replace(/\n/g, '<br />') );

      // $("#popup_container").css({
      // 	minWidth: $("#popup_container").outerWidth(),
      // 	maxWidth: $("#popup_container").outerWidth()
      // });

      $.alerts._reposition()
      $.alerts._maintainPosition(true)
      $('#popup_close').click(function () {
        $.alerts._hide()
        if (callback) callback()
      })
      switch (type) {
        case 'alert':
          $('#popup_message').after('<div id="popup_panel"><a href="javascript:void(0)" id="popup_ok">' + ok + '</a></div>')
          $('#popup_ok').click(function () {
            $.alerts._hide()
            if (callback) callback(true)
          })
          $('#popup_ok').focus().keypress(function (e) {
            if (e.keyCode == 13 || e.keyCode == 27) $('#popup_ok').trigger('click')
          })
          break
        case 'confirm':
          $('#popup_message').after('<div id="popup_panel"><a href="javascript:void(0)" id="popup_ok">' + ok + '</a> <a href="javascript:void(0)" id="popup_cancel">' + cancel + ' </a></div>')
          $('#popup_ok').click(function () {
            $.alerts._hide()
            if (callback) callback(true)
          })
          $('#popup_cancel').click(function () {
            $.alerts._hide()
            if (callback) callback(false)
          })
          // $("#popup_ok").focus();
          $('#popup_ok, #popup_cancel').keypress(function (e) {
            if (e.keyCode == 13) $('#popup_ok').trigger('click')
            if (e.keyCode == 27) $('#popup_cancel').trigger('click')
          })
          break
        case 'prompt':
          $('#popup_message').append('<br /><input type="text" size="30" id="popup_prompt" />').after('<div id="popup_panel"><a href="javascript:void(0)" id="popup_ok">' + ok + '</a> <a href="javascript:void(0)" id="popup_cancel">' + cancel + ' </a></div>')
          $('#popup_prompt').width($('#popup_message').width())
          $('#popup_ok').click(function () {
            var val = $('#popup_prompt').val()
            $.alerts._hide()
            if (callback) callback(val)
          })
          $('#popup_cancel').click(function () {
            $.alerts._hide()
            if (callback) callback(null)
          })
          $('#popup_prompt, #popup_ok, #popup_cancel').keypress(function (e) {
            if (e.keyCode == 13) $('#popup_ok').trigger('click')
            if (e.keyCode == 27) $('#popup_cancel').trigger('click')
          })
          if (value) $('#popup_prompt').val(value)
          $('#popup_prompt').focus().select()
          break
      }

      // Make draggable
      // if ($.alerts.draggable) {
      //   try {
      //     $('#popup_container').draggable({handle: $('#popup_title')})
      //     $('#popup_title').css({cursor: 'move'})
      //   } catch (e) { /* requires jQuery UI draggables */ }
      // }
    },

    _hide: function () {
      $('#popup_container').remove()
      $.alerts._overlay('hide')
      $.alerts._maintainPosition(false)
    },

    _overlay: function (status) {
      switch (status) {
        case 'show':
          $.alerts._overlay('hide')
          $('BODY').append('<div id="popup_overlay"></div>')
          $('#popup_overlay').css({
            position: 'fixed',
            zIndex: 99998,
            top: '0px',
            left: '0px',
            width: '100%',
            height: $(document).height(),
            background: $.alerts.overlayColor,
            opacity: $.alerts.overlayOpacity
          })
          break
        case 'hide':
          $('#popup_overlay').remove()
          break
      }
    },

    _reposition: function () {
      var top = (($(window).height() / 2) - ($('#popup_container').outerHeight() / 2)) + $.alerts.verticalOffset
      var left = (($(window).width() / 2) - ($('#popup_container').outerWidth() / 2)) + $.alerts.horizontalOffset
      if (top < 0) top = 0
      if (left < 0) left = 0

      $('#popup_container').css({
        top: top + 'px',
        left: left + 'px'
      })
      $('#popup_overlay').height($(document).height())
    },

    _maintainPosition: function (status) {
      if ($.alerts.repositionOnResize) {
        switch (status) {
          case true:
            $(window).bind('resize', function () {
              $.alerts._reposition()
            })
            break
          case false:
            $(window).unbind('resize')
            break
        }
      }
    },
    _closeAlerts: function () {
      var button = $('#popup_cancel').length ? $('#popup_cancel') : $('#popup_ok')
      button.click()
    }
  }

  // Shortuct functions
  jAlert = function (message, callback, ok) {
    $.alerts.alert(message, ok, callback)
  }

  jConfirm = function (message, callback, ok, cancel) {
    $.alerts.confirm(message, ok, cancel, callback)
  }

  jPrompt = function (message, value, callback, ok, cancel) {
    $.alerts.prompt(message, value, ok, cancel, callback)
  }

})(jQuery)


// WEBPACK FOOTER //
// ./src/js/libs/utils-alerts.js